<template>
  <div style="overflow: hidden; position: relative;">
    <div class="r-header">
      <el-input v-model="employeeName" placeholder="姓名" clearable @keyup.enter.native="onSearch('search')"></el-input>
      <el-select v-model="dept" clearable  placeholder="部门">
        <el-option v-for="item in options" :key="item.value" :label="item.name" :value="item.value">
        </el-option>
      </el-select>
      <el-button type="primary" plain @click="onSearch('search')">查询</el-button>
      <ElXlsx @upData="upData" :isPlain="true" />
      <span style="font-size: 10px;
    padding: 16px 5px 2px 1px;
    font-style: italic;
    color: gray;">每次上传后都将覆盖上次数据</span>
      <!-- <el-button type="primary" plain @click="reportTable">Excle导出</el-button> -->
      <!-- <el-button type="primary" @click="addMethod()">新增</el-button> -->
    </div>
    <el-table :data="tableData" style="width: 100%;" max-height="654" border v-loading="loading" ref="report-table">
      <el-table-column prop="period" label="月度信息"></el-table-column>
      <el-table-column prop="employeeName" label="姓名"></el-table-column>
      <el-table-column prop="dept" label="部门"></el-table-column>
      <el-table-column prop="monthScore" label="本月积分"></el-table-column>
      <el-table-column prop="totalScore" label="当前累计积分"></el-table-column>
<!--      <el-table-column fixed="right" label="操作" width="150" v-if="!noReport">
        <template slot-scope="scope">
          <el-button @click.native.prevent="changeRow(scope.$index, tableData)" icon="el-icon-edit" type="text">
            修改
          </el-button>
          <el-button @click.native.prevent="deleteRow(scope.$index, tableData)" icon="el-icon-delete" type="text">
            删除
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page="page" :page-size="rows"
      layout="total, prev, pager, next, jumper" :total="total">
    </el-pagination>

    <el-dialog :title="(flag === 'add' ? '新增':'修改')+'详情页'" :visible.sync="dialogVisible" width="40%" top="18vh"
      @close="handleClose" :modal-append-to-body="false" :append-to-body="true">
      <div class="cont-box">
        <el-form :inline="true" :model="rosterImport" class="my-form" ref="rosterImport" :rules="rule01">
          <el-form-item prop="employeeName" label="姓名">
            <el-input v-model="rosterImport.employeeName" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="dept" label="部门">
            <el-input v-model="rosterImport.dept" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="monthScore" label="本月积分">
            <el-input v-model="rosterImport.monthScore" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item prop="totalScore" label="当前累计积分">
            <el-input v-model="rosterImport.employeeName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="subCont('rosterImport')">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入确认" :visible.sync="dialogConfirm" width="90%" top="8vh" @close="dialogConfirm = false"
      :modal-append-to-body="false" :append-to-body="true">
      <IntegralConfirm :datas="dataArr"></IntegralConfirm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogConfirm = false">取 消</el-button>
        <el-button type="primary" @click="importSub" :disabled="btnDisabled">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import XLSX from 'xlsx'
  import FileSaver from 'file-saver'

  import ElXlsx from '../../components/ElXlsx.vue'
  import IntegralConfirm from '../../components/IntegralConfirm.vue'
  export default {
    name: 'Roster',
    components: {
      ElXlsx,
      IntegralConfirm
    },
    data() {
      return {
        noReport: false,
        btnDisabled: false,
        dataArr: [],
        loading: true,
        dialogVisible: false,
        dialogConfirm: false,
        drawer: false,
        employeeName: '',
        dept: '',
        rosterImport: {
          employeeName: '',
          dept: '',
          monthScore: '',
          totalScore: ''
        },
        flag: 'add',
        tableData: [],
        curData: {},
        rule01: {
          employeeName: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          dept: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          monthScore: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }],
          totalScore: [{
            required: true,
            message: '请输入',
            trigger: 'blur'
          }]
        },
        page: 1,
        rows: 10,
        total: null,
        items: ['period', 'employeeName', 'dept', 'monthScore', 'totalScore'],
        options: []
      }
    },
    mounted() {
      this.getList()
      this.getdept()
    },
    methods: {
      reportTable() {
        this.noReport = true
        this.asyncGetList()
      },
      async asyncGetList() {
        this.rows = -1
        await this.getList()
        this.exportExcel('学习积分')
        this.noReport = false
        this.rows = 10
        this.page = 1
        this.tableData.splice(10)
      },
      exportExcel(excelName) {
        try {
          const $e = this.$refs['report-table'].$el;
          let $table = $e.querySelector('.el-table__fixed');
          if (!$table) {
            $table = $e;
          }
          // 为了返回单元格原始字符串，设置{ raw: true }
          const wb = XLSX.utils.table_to_book($table, {
            raw: true
          });
          const wbout = XLSX.write(wb, {
            bookType: 'xlsx',
            bookSST: true,
            type: 'array'
          });
          FileSaver.saveAs(
            new Blob([wbout], {
              type: 'application/octet-stream'
            }), `${excelName}.xlsx`)
        } catch (e) {
          if (typeof console !== 'undefined') console.error(e);
        }
      },
      importSub() {
        this.btnDisabled = true
        this.$axios.post('/hr-learning-score/saveBatch', this.dataArr).then(res => {
          this.$message({
            type: res.data.code === 400 ? 'error' : 'success',
            message: res.data.code === 400 ? res.data.msg : '添加成功。'
          })
          this.dialogConfirm = false
          this.btnDisabled = false
          this.getList()
        }).finally(() => this.btnDisabled = false)
      },
      upData(e) {
        try {
          let dataArr = this.$replaceString(e, this.items)
          this.dataArr = dataArr
          this.dialogConfirm = true
        } catch {
          this.$message({
            message: '文件格式错误！',
            type: 'warning'
          })
        }
      },
      bindInputIdCard(e) {
        this.rosterImport.birthday = e.substring(6, 10) + "-" + e.substring(10, 12) + "-" + e.substring(12, 14)
      },
      async getList(e) {
        this.loading = true
        if (e === 'search') {
          this.page = 1
        }
        await this.$axios.post('/hr-learning-score/findListPage', {
          current: this.page,
          size: this.rows,
          employeeName: this.employeeName.trim(),
          dept: this.dept
        }).then(res => {
          this.loading = false
          this.tableData = res.data.data.records
          this.total = res.data.data.total
        })
      },
      getdept() {
        this.$axios.get('/hr-learning-score/findDeptList').then(res => {
          this.options = res.data.data
        })
      },
      deleteRow(index, rows) {
        var that = this
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$axios.post('/hr-employees/remove', {
            id: rows[index].id,
            idCard: rows[index].idCard
          }).then(res => {
            that.$message({
              type: res.data.code === 400 ? 'error' : 'success',
              message: res.data.code === 400 ? res.data.msg : '删除成功。'
            })
            this.getList()
          })
        })
      },
      handleCurrentChange(val) {
        this.page = val
        this.getList()
      },
      addMethod() {
        this.rosterImport = {}
        this.dialogVisible = true
        this.flag = 'add'
      },
      changeRow(index, data) {
        this.dialogVisible = true
        this.rosterImport = JSON.parse(JSON.stringify(data[index]))
        this.flag = 'change'
      },
      onSearch(e) {
        this.getList(e)
      },
      subCont(formName) {
        var that = this
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.rosterImport.corp = '0'
            if (this.flag === 'add') {
              this.$axios.post('/hr-employees/saveOrUpdate ', this.rosterImport).then(res => {
                that.dialogVisible = false
                that.$message({
                  type: res.data.code === 400 ? 'error' : 'success',
                  message: res.data.code === 400 ? res.data.msg : '添加成功。'
                })
                that.getList()
              })
            } else {
              this.$axios.post('/hr-employees/saveOrUpdate', this.rosterImport).then(res => {
                that.$message({
                  type: res.data.code === 400 ? 'error' : 'success',
                  message: res.data.code === 400 ? res.data.msg : '更新成功。'
                })
                that.getList()
              })
            }
            this.dialogVisible = false
          } else {
            return false;
          }
        })
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },
      handleClose() {
        this.resetForm('rosterImport')
      }
    }
  }
</script>

<style scoped>
  .r-header {
    display: flex;
    margin-bottom: 20px;
  }

  .r-header .el-input {
    width: 260px;
    margin-right: 6px;
  }

  .r-header>>>.el-button {
    margin-left: 0;
  }

  .el-table {
    box-sizing: border-box;
  }

  .drawer-cont {
    box-sizing: border-box;
    padding: 0 20px;
  }

  .el-tag {
    /* cursor: pointer; */
    padding: 0 24px;
  }

  .el-table>>>.cell .el-button {
    padding: 0;
  }

  /*  .el-dialog__wrapper {
    height: 100%;
  }
  .el-dialog__wrapper >>> .el-dialog {
    height: 80%;
    overflow-y: auto;
  } */
  .cont-box {
    padding: 0 10px;
    /* overflow-y: auto; */
  }

  .list-cont {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont01 {
    display: flex;
    flex-wrap: wrap;
    margin: 0 1em;
    padding: 14px 0;
  }

  .list-cont li {
    width: 25%;
    display: flex;
    padding: 6px 0;
    align-items: center;
  }

  .list-cont01>div {
    width: 25%;
    display: flex;
    padding: 6px 0;
    align-items: center;
    margin-bottom: 0;
  }

  .title {
    line-height: 34px;
    background: #f9f9f9;
    text-indent: 1em;
    color: #999999;
  }

  .list-cont li>label {
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__label {
    white-space: nowrap;
  }

  .list-cont01>div>>>.el-form-item__content {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .list-cont li>p {
    flex: 1;
    color: #323232;
    margin: 0 10px;
    min-height: 20px;
    border-bottom: 1px solid #dedede;
  }

  .list-cont li>.el-input,
  .list-cont li>.el-select,
  .list-cont li>.el-textarea {
    flex: 1;
    margin: 0 1em 0 .5em;
  }

  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }

  .el-select {
    width: 140px;
    margin-right: 6px;
  }

  .my-form {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }

  .my-form>.el-form-item {
    box-sizing: border-box;
    width: 50%;
    margin: 0;
    padding: 10px;
    display: flex;
  }

  .my-form>>>.el-form-item__label {
    white-space: nowrap;
  }

  .my-form>>>.el-form-item__content {
    flex: 1;
  }

  .upload {
    display: inline-block;
    margin-right: 6px;
  }

  .el-button {
    margin-right: 6px;
  }
</style>